import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getWard,
  getParticularPage,
  getNext,
  getPrevious,
  createWard,
  updateWard,
  handleSearch,
  getWardById,
} from "./thunk";

const initialState = {
  wards: [],
  edit: false,
  ward: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingWard: false,
  loadingNext: false,
  showCreateModal: false,
};

export const wardSlice = createSlice({
  name: "ward",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllWard: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingWard = false;
      state.ward = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createWard.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createWard.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createWard.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(getWardById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWardById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.ward = action.payload.data;
    });
    builder.addCase(getWardById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
      state.ward = null;
    });
    builder.addCase(updateWard.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateWard.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateWard.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(getWard.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingWard = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getWard.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingWard = false;
        state.wards = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getWard.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingWard = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllWard } = wardSlice.actions;

export default wardSlice.reducer;
